import { DialogConfig } from './dialog-config.model';
import { StripMethods, DataPartial } from '@webtronic-labs/contracts-proflyt';
import { DialogType, DialogSeverity } from '../../enums';

export class DialogConfigMock extends DialogConfig {
  constructor(data?: DataPartial<DialogConfig>) {
    const seedData: StripMethods<DialogConfig> = {
      ...data,
      title: 'Hello there',
      content: 'Content placeholder',
      type: DialogType.JustText,
      timeout: 10000,
      id: 'uniqueID',
      destroyed: false,
      opaqueBackground: true,
      canBeDismissed: true,
      severity: DialogSeverity.Default,
    };
    super(seedData);
  }
}
